"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemainingDrivingTimeSchema = void 0;
const zod_1 = require("zod");
exports.RemainingDrivingTimeSchema = zod_1.z.object({
    todaysRemainingDrivingTimeSeconds: zod_1.z.number().int().nonnegative(),
    dailyDrivingLimitSeconds: zod_1.z.number().int().positive(),
    thisWeeksRemainingDrivingTimeExtensionDays: zod_1.z.number().int().nonnegative(),
    dataTimestamp: zod_1.z.string().datetime(),
    state: zod_1.z.string(),
});
//# sourceMappingURL=remainingDrivingTime.js.map